<template>
    <v-snackbar
        v-model="active"
        :color="properties.color"
        top
        :timeout="properties.timeout">
        <div class="snackbar-content">
            <v-icon color="white" class="icon type-icon">{{ properties.icon }}</v-icon>
            <span class="alert-text">{{ properties.message }}</span>
            <v-icon color="white" class="icon close-btn" @click="active = false">mdi-close</v-icon>
        </div>
    </v-snackbar>
</template>

<script>
export default {
    name: 'OfflineModal',
    data() {
        return {
            active: false,
            properties: {
                timeout: 6000,
                message: '',
                color: 'info',
                icon: 'mdi-close',
            },
            internalIsOffline: false,

            checkInterval: null
        };
    },
    mounted() {
        // 1. Listeners estándar (Funcionan perfecto en desconexión real/celulares)
        window.addEventListener('online', this.updateStatus);
        window.addEventListener('offline', this.updateStatus);

        // 2. Verificación inicial
        this.updateStatus();

        // 3. RED DE SEGURIDAD (POLLING):
        // Revisa cada 3 segundos si el navegador cambió de opinión sin avisar.
        // Esto ayuda mucho a detectar la simulación "Offline" de las DevTools.
        this.checkInterval = setInterval(() => {
            this.updateStatus();
        }, 3000);
    },
    beforeUnmount() {
        window.removeEventListener('online', this.updateStatus);
        window.removeEventListener('offline', this.updateStatus);

        if (this.checkInterval) clearInterval(this.checkInterval);
    },
    methods: {
        updateStatus() {
            const isCurrentlyOffline = !navigator.onLine;

            if (isCurrentlyOffline !== this.internalIsOffline) {

                this.internalIsOffline = isCurrentlyOffline;

                if (isCurrentlyOffline) {
                    // SE FUE EL INTERNET
                    this.show({
                        type: 'error',
                        message: 'No hay conexión a internet.',
                        timeout: -1 // Fijo
                    });
                } else {
                    // VOLVIÓ EL INTERNET

                    this.show({
                        type: 'success',
                        message: 'Conexión restablecida.',
                        timeout: 2000
                    });
                }
            }
        },
        show(customProps) {
             Object.assign(this.properties, customProps);

            switch (customProps.type) {
                case 'success':
                    this.properties.color = '#4caf50';
                    this.properties.icon = 'mdi mdi-check-circle';
                    if (!customProps.timeout) this.properties.timeout = 3000;
                    break;
                case 'error':
                    this.properties.color = 'error';
                    this.properties.icon = 'mdi mdi-wifi-off';
                    if (customProps.timeout === undefined) this.properties.timeout = 7000;
                    break;
                case 'warning':
                    this.properties.color = '#fb8c00';
                    this.properties.icon = 'mdi mdi-alert';
                    if (!customProps.timeout) this.properties.timeout = 5000;
                    break;
                case 'info':
                default:
                    this.properties.color = '#2196f3';
                    this.properties.icon = 'mdi mdi-information';
                    if (!customProps.timeout) this.properties.timeout = 4000;
                    break;
            }

            if (customProps.timeout !== undefined) {
                this.properties.timeout = customProps.timeout;
            }

            this.active = true;
        },
    },
};
</script>

<style>
    .snackbar-content{
        display:flex;
        flex-direction:row;
        justify-content: space-between;
    }
</style>
